import { render, staticRenderFns } from "./FeaturedPhoto.vue?vue&type=template&id=10acd649&"
import script from "./FeaturedPhoto.vue?vue&type=script&lang=js&"
export * from "./FeaturedPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports